// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2eaLd","footer":"ModalFilter_footer__1AI8Z"};